import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const ProductGallery = ({ name, images }) => {
  const [active, setActive] = useState(0);

  return (
    <div className="relative md:h-[calc(100vh-5rem)] md:sticky md:top-20 flex flex-col md:flex-row">
      <div className="relative flex-1 bg-[#D4D7DD] overflow-hidden order-1">
        <AnimatePresence mode="wait">
          <motion.img
            key={active}
            src={images[active]}
            alt={`${name} — view ${active + 1}`}
            data-testid="gallery-main-image"
            initial={{ opacity: 0, scale: 1.03 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5, ease }}
            className="w-full h-full object-cover aspect-[3/4] md:aspect-auto"
          />
        </AnimatePresence>
        <span className="absolute top-4 left-4 label bg-[#EDEEF1]/85 text-[#0B0E14] px-2 py-1">
          {String(active + 1).padStart(2, "0")} / {String(images.length).padStart(2, "0")}
        </span>
      </div>
      {images.length > 1 && (
        <div className="flex md:flex-col gap-3 p-3 md:p-4 bg-[#EDEEF1]" data-testid="gallery-thumbs">
          {images.map((src, i) => (
            <button
              key={src}
              data-testid={`gallery-thumb-${i}`}
              onMouseEnter={() => setActive(i)}
              onClick={() => setActive(i)}
              className={`relative w-16 h-20 md:w-20 md:h-28 overflow-hidden border-2 transition-colors duration-300 ${active === i ? "border-[#0B0E14]" : "border-transparent opacity-60 hover:opacity-100"}`}
            >
              <img src={src} alt={`${name} view ${i + 1}`} className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
